class BaseAPI {
  constructor(props) {
    this.props = props;
  }

  makeSecureHeader = () => {
    return new Headers({
      Authorization: `Token ${window.sessionStorage.getItem("user_session_id")}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  };

  makeUnSecureHeaders = () => {
    return new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
    });
  };

  headers = () => {
    if (window.sessionStorage.getItem("user_session_id")) { // checking if user is logged in then create create header with token
      return this.makeSecureHeader();
    } else {
      return this.makeUnSecureHeaders();
    }
  };

  fetchSecure = ({ url }) => {
    return fetch(url, {
      method: "GET",
      headers: this.headers(),
    });
  };

  postSecure = ({ url, data }) => {
    return fetch(url, {
      method: "POST",
      headers: this.headers(),
      body: JSON.stringify({ ...data }),
    });
  };
}

export default BaseAPI;
